import { render, staticRenderFns } from "./component.vue?vue&type=template&id=bdab0ed8&scoped=true"
import script from "./component.vue?vue&type=script&lang=js"
export * from "./component.vue?vue&type=script&lang=js"
import style0 from "./component.scss?vue&type=style&index=0&id=bdab0ed8&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdab0ed8",
  null
  
)

export default component.exports